<template>
  <div
    class="sf-alert tw-py-2 tw-pl-7 tw-pr-4 sf-below-2 sf-hover"
    :class="alertBannerStyleClass"
    data-testid="workflow-review-status-container"
  >
    <div class="sf-level sf-level-between">
      <!-- Who reviewed -->
      <div v-if="reviewed">
        <i
          v-if="hasAnyUpToDateReview"
          class="icon icon-check sf-c-text-dark sf-pad-r-1"
          :class="{ 'sf-c-success': hasUpToDateReviewByUser }"
        />
        <workflow-review-status-reviewed-by
          :has-any-up-to-date-review="hasAnyUpToDateReview"
          :reviews-to-show="reviewsToShow"
        />
      </div>
      <div v-if="!reviewed">
        {{ I18n.t('reconciliation_review.no_reviews') }}
      </div>
      <!-- Action button -->
      <div class="tw-flex tw-self-end tw-gap-x-4">
        <a
          v-if="hasUpToDateReviewByUser"
          class="sf-btn sf-hover-item"
          style="opacity: 1"
          :data-heap="`${trackingPrefix}-review-status-mark-as-unreviewed`"
          @click.stop.prevent="unmark"
        >
          <span class="sf-hover-item-hide">{{
            I18n.t('reconciliation_review.reviewed')
          }}</span>
          <span class="sf-hover-item-show sf-c-text">{{
            I18n.t('reconciliation_review.unmark')
          }}</span>
        </a>
        <a
          v-else
          :data-heap="`${trackingPrefix}-review-status-mark-as-reviewed`"
          class="sf-btn"
          @click.stop.prevent="markAsReviewed"
          >{{ I18n.t('reconciliation_review.mark_as_reviewed') }}</a
        >
      </div>
    </div>
  </div>
</template>

<script>
import WorkflowReviewStatusReviewedBy from '@app/application/workflows/screens/workflow-review/components/workflow-review-status-reviewed-by.vue'

const WorkflowReviewStatusBlock = {
  props: [
    'hasAnyUpToDateReview',
    'hasUpToDateReviewByUser',
    'reviewed',
    'reviewsToShow',
    'trackingPrefix',
  ],
  emits: ['mark-as-reviewed', 'unmark'],
  components: { WorkflowReviewStatusReviewedBy },
  computed: {
    alertBannerStyleClass() {
      return this.hasUpToDateReviewByUser
        ? 'sf-alert-success'
        : 'sf-bg-text-lighter'
    },
  },
  methods: {
    markAsReviewed() {
      this.$emit('mark-as-reviewed')
    },
    unmark() {
      this.$emit('unmark')
    },
  },
}

export default WorkflowReviewStatusBlock
</script>
